<template>
  <div class="crop-editor">
    <cropper-box
      v-model="cutPost"
      :rotate="rotate"
      :ratio="ratio"
    >
      <video
        ref="videoDom"
        :src="videoUrl"
        @canplay="canPlayFunc"
        @timeupdate="timeupdate"
        @durationchange="durationchange"
      ></video>
    </cropper-box>
  </div>
</template>
<script>
export default {
  name: 'CropEditor',
  components: {
    CropperBox: () => import('@/components/common/cropperBox')
  },
  props: {
    videoUrl: {
      type: String,
      default: ''
    },
    volume: {
      type: Number,
      default: 1
    },
    rotate: {
      type: Number,
      default: 0
    },
    ratio: {
      type: Number,
      default: -1
    },
    matrix: {
      type: Object,
      required: true,
      default: function() {
        return {
          w: 0,
          h: 0,
          x: 0,
          y: 0
        };
      }
    }
  },
  data() {
    return {
      playing: false,
      times: 0,
      canPlay: false,
      duration: 0,
      cutPost: { x: 0, y: 0, width: 0, height: 0 }, //裁剪框大小
      fixedRatio: false,
      ratioModes: [
        {
          type: '1X1',
          value: {
            width: 1,
            height: 1
          }
        },
        {
          type: '16X9',
          value: {
            width: 16,
            height: 9
          }
        },
        {
          type: '9X16',
          value: {
            width: 9,
            height: 16
          }
        },
        {
          type: '5X4',
          value: {
            width: 5,
            height: 4
          }
        }
      ]
    };
  },
  watch: {
    volume() {
      this.$refs.videoDom.volume = this.volume;
    },
    rotate() {
      //console.log('aaaa');
    }
  },
  mounted() {
    this.$nextTick(() => {
      // if (this.$refs.videoDom) {
      //   this.$refs.videoDom.addEventListener('canplay', this.canPlayFunc);
      //   this.$refs.videoDom.addEventListener('timeupdate', this.timeupdate);
      //   this.$refs.videoDom.addEventListener('durationchange', this.durationchange);
      // }
    });
  },
  beforeDestroy() {
    this.$refs.videoDom.removeEventListener('canplay', this.canPlayFunc);
    this.$refs.videoDom.removeEventListener('timeupdate', this.timeupdate);
    this.$refs.videoDom.removeEventListener('durationchange', this.durationchange);
    this.$refs.videoDom = null;
  },
  methods: {
    canPlayFunc() {
      if (!this.canPlay) {
        this.canPlay = true;
        this.$emit('canPlay', this.duration);
      }
    },
    durationchange() {
      this.canPlay = false;
      this.duration = this.$refs.videoDom.duration;
    },
    videoPlay(data) {
      if (typeof data.time === 'number') {
        this.currentTime(data.time);
      }
      if (data.play) {
        this.play();
      } else {
        this.pause();
      }
    },
    play() {
      if (!this.canPlay) return;
      this.$refs.videoDom.play();
      this.playing = true;
    },
    pause() {
      if (!this.canPlay) return;
      this.$refs.videoDom.pause();
      this.playing = false;
    },
    currentTime(time) {
      if (!this.canPlay) return;
      this.$refs.videoDom.currentTime = time;
    },
    timeupdate() {
      if (!this.playing) return;
      let ct = this.$refs.videoDom.currentTime;
      if (ct >= this.duration) {
        this.$emit('ended');
      }
      this.$emit('timeupdate', ct);
    },
    getPostInfo() {
      let obj = {};
      obj.pointX = this.cutPost.x;
      obj.pointY = this.cutPost.y;
      obj.width = this.cutPost.width;
      obj.height = this.cutPost.height;
      obj.sWidth = this.$refs.videoDom.videoWidth;
      obj.sHeight = this.$refs.videoDom.videoHeight;

      return obj;
    }
  }
};
</script>
<style lang="scss" scoped>
.crop-editor {
  position: relative;
  width: 100%;
  height: 100%;

  // .video {
  //   position: relative;
  //   max-width: 100%;
  //   max-height: 100%;
  // }
}
</style>
